import { FINANCIAL_INFO_VIEWS_PATHS } from '../FinancialInfo.constants';

export const RECORD_NOUN_BY_TABLE_PATH = {
  [FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES]: { singular: 'liability', plural: 'liabilities' },
  [FINANCIAL_INFO_VIEWS_PATHS.ASSETS]: { singular: 'asset', plural: 'assets' },
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: { singular: 'property', plural: 'properties' },
  [FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT]: { singular: 'income', plural: 'incomes' },
};

export const DEFAULT_RECORD_NOUN = { singular: 'record', plural: 'records' };

export const SAVE_BLOCKED_GENERIC_MESSAGE = "Can't save: some fields are invalid.";
